export const UserAvailability = {
  REQUIRE_NONE: 'REQUIRE_NONE',
  REQUIRE_USER_FOLLOW_AUTHOR: 'REQUIRE_FOLLOWING',
  REQUIRE_AUTHOR_FOLLOW_USER: 'REQUIRE_FOLLOWED',
  REQUIRE_MUTUAL_FOLLOW: 'REQUIRE_MUTUAL_FOLLOWING',
} as const;
export type UserAvailability =
  typeof UserAvailability[keyof typeof UserAvailability];
